export const LIKE_REACTION_KEY = 'like';
//# sourceMappingURL=index.js.map